<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-select--label mb-2">{{ $t("SearchParty") }}</label>
            <treeselect
              name="party"
              :multiple="false"
              :placeholder="$t('SearchParty')"
              :async="true"
              :load-options="loadOptions"
              class="search-input"
              @select="onPartySelected"
              @input="onPartyChange"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vs-button
              @click="uploadFile()"
              class="bg_m_green float-right mt-4"
              v-if="fileUploaded"
              :disabled="disabledBtn"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("Submit") }}
            </vs-button>
            <label class="custom-file-upload mt-4 float-right">
              <input
                type="file"
                id="file"
                ref="file"
                v-on:change="handleFileUpload()"
              />
              <feather-icon
                icon="PaperclipIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              {{ $t("AddReturnOrderViaExcel") }}
              <span v-if="uploadedFileName" class="file-name">{{
                uploadedFileName
              }}</span>
            </label>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col md:w-1/2 w-full" v-if="partySelected">
            <label class="vs-select--label mb-2">{{ $t("SelectOrder") }}</label>
            <v-select
              label="id"
              :options="allOrders"
              :get-option-label="getLabel"
              :reduce="(x) => x.id"
              v-model="model.orderId"
              @input="selectOrder"
              ref="orderSelect"
              :loading="allOrdersLoading"
              dir="rtl"
            >
            </v-select>
          </div>
        </div>
        <div v-if="loadTable">
          <div v-if="!orderInfoLoading">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="vx-card mb-4">
                  <div class="vx-card__header">
                    <div class="vx-card__title">
                      <h4>{{ $t("PartyInfo") }}</h4>
                    </div>
                  </div>
                  <div
                    class="vx-card__collapsible-content vs-con-loading__container"
                  >
                    <div class="vx-card__body custom-tbl">
                      <vs-table :data="orderInfo" ref="table">
                        <template slot="thead">
                          <vs-th style="width: 15%">{{ $t("Name") }}</vs-th>
                          <vs-th style="width: 15%">{{
                            $t("PartyType")
                          }}</vs-th>

                          <vs-th style="width: 15%">
                            <span
                              v-if="
                                orderInfo.orderPartyInfoQueryDto.partyType ==
                                'حقیقی'
                              "
                              >{{ $t("SocialSecurityNumber") }}</span
                            >
                            <span
                              v-else-if="
                                orderInfo.orderPartyInfoQueryDto.partyType ==
                                'حقوقی'
                              "
                            >
                              {{ $t("CompanyNationalId") }}
                            </span>
                          </vs-th>
                          <vs-th style="width: 15%">{{
                            $t("PhoneNumber")
                          }}</vs-th>
                          <vs-th style="width: 25%">{{ $t("Address") }}</vs-th>
                          <vs-th style="width: 15%">{{
                            $t("PostalCode")
                          }}</vs-th>
                        </template>
                        <template :name="{ data }" slot-scope="{ data }">
                          <vs-tr>
                            <vs-td>
                              {{ orderInfo.orderPartyInfoQueryDto.name }}
                            </vs-td>
                            <vs-td>
                              {{ orderInfo.orderPartyInfoQueryDto.partyType }}
                            </vs-td>
                            <vs-td
                              v-if="
                                orderInfo.orderPartyInfoQueryDto.partyType ==
                                'حقیقی'
                              "
                            >
                              <span
                                v-if="
                                  !orderInfo.orderPartyInfoQueryDto
                                    .socialSecurityNumber
                                "
                              >
                                -
                              </span>
                              {{
                                orderInfo.orderPartyInfoQueryDto
                                  .socialSecurityNumber
                              }}
                            </vs-td>
                            <vs-td
                              v-if="
                                orderInfo.orderPartyInfoQueryDto.partyType ==
                                'حقوقی'
                              "
                            >
                              <span
                                v-if="
                                  !orderInfo.orderPartyInfoQueryDto
                                    .companyNationalId
                                "
                              >
                                -
                              </span>
                              {{
                                orderInfo.orderPartyInfoQueryDto
                                  .companyNationalId
                              }}
                            </vs-td>
                            <vs-td>
                              <div
                                v-for="item in orderInfo.orderPartyInfoQueryDto
                                  .orderPhonesQuery"
                                :key="item.number"
                                class="flex flex-col"
                              >
                                <div style="direction: ltr">
                                  <span>{{ item.area }}</span>
                                  {{ item.number }}
                                </div>
                              </div>
                            </vs-td>
                            <vs-td>
                              <div
                                v-for="(item, index) of orderInfo
                                  .orderPartyInfoQueryDto
                                  .orderAddressesInfoQuery"
                                :key="index"
                                class="flex flex-col"
                              >
                                <div v-if="item">
                                  {{ item.orderProvinceInfoQuery.name }}-{{
                                    item.orderProvinceInfoQuery.cityName
                                  }}-{{ item.address }}
                                </div>
                              </div>
                            </vs-td>
                            <vs-td>
                              <div
                                v-for="(item, index) in orderInfo
                                  .orderPartyInfoQueryDto
                                  .orderAddressesInfoQuery"
                                :key="index"
                                class="flex flex-col"
                              >
                                <div v-if="item">
                                  {{ item.postalCode }}
                                </div>
                              </div>
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="vx-card mb-4">
                  <div class="vx-card__header">
                    <div class="vx-card__title w-full">
                      <h4>
                        {{ $t("OrdersList") }}
                        {{ $t("From") }}
                        {{ $t("Contract") }}:
                        <span class="color-primary">{{
                          orderInfo.orderContractQuery.contractTitle
                        }}</span>
                        <span class="date float-right">
                          <span> {{ $t("CreateOn") }}: </span>
                          <span class="float-right">
                            {{ orderInfo.createOn }}
                          </span>
                        </span>
                      </h4>
                    </div>
                  </div>
                  <div
                    class="vx-card__collapsible-content vs-con-loading__container"
                  >
                    <div class="vx-card__body custom-tbl" id="draft-order-tbl">
                      <vs-table
                        :data="orderInfo.ordersItemsQueryDto"
                        ref="table"
                      >
                        <template slot="thead">
                          <vs-th style="width: 3%">#</vs-th>
                          <vs-th style="width: 14%">{{
                            $t("ProductName")
                          }}</vs-th>
                          <vs-th style="width: 5%">{{
                            $t("OrderCount")
                          }}</vs-th>
                          <vs-th style="width: 8%">{{ $t("ItemCode") }}</vs-th>
                          <vs-th style="width: 5%">{{
                            $t("ReturnOrderCount")
                          }}</vs-th>
                          <vs-th style="width: 11%">{{
                            $t("UnitPrice")
                          }}</vs-th>
                          <vs-th style="width: 11%">{{
                            $t("TotalAmount")
                          }}</vs-th>
                          <vs-th style="width: 10%">{{
                            $t("SumOfDiscount")
                          }}</vs-th>
                          <vs-th style="width: 12%">{{
                            $t("TotalTaxAmount")
                          }}</vs-th>
                          <vs-th style="width: 13%">{{
                            $t("TotalAmountWithTax")
                          }}</vs-th>
                          <vs-th style="width: 8%">{{ $t("Action") }}</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                          <vs-tr
                            v-for="(tr, indextr) in data"
                            :data="tr"
                            :key="indextr"
                          >
                            <vs-td :data="data[indextr]">
                              {{ parseInt(indextr) + 1 }}
                            </vs-td>
                            <vs-td
                              :data="
                                data[indextr].orderProductInfoQuery.productName
                              "
                            >
                              {{
                                data[indextr].orderProductInfoQuery.productName
                              }}
                            </vs-td>
                            <vs-td>
                              {{ data[indextr].count }}
                            </vs-td>
                            <vs-td>
                              {{ data[indextr].orderProductInfoQuery.itemCode }}
                            </vs-td>
                            <vs-td :data="data[indextr].returnCount">
                              <input
                                class="inputx mb-4 mt-1 text-center vs-input--input"
                                type="text"
                                v-model="data[indextr].returnCount"
                                @change="changeCount([indextr], $event)"
                                :disabled="
                                  data[indextr].orderProductInfoQuery
                                    .serializeSerial != ''
                                "
                              />
                            </vs-td>
                            <vs-td :data="data[indextr].unitPrice">
                              {{
                                Number(data[indextr].unitPrice).toLocaleString()
                              }}
                              ریال
                            </vs-td>
                            <vs-td :data="data[indextr].totalAmount">
                              {{
                                Number(
                                  data[indextr].totalAmount
                                ).toLocaleString()
                              }}
                              ریال
                            </vs-td>
                            <vs-td :data="data[indextr].sumOfDiscount">
                              <span v-if="data[indextr].sumOfDiscount">
                                {{
                                  Number(
                                    data[indextr].sumOfDiscount
                                  ).toLocaleString()
                                }}
                                ریال
                              </span>
                              <span v-else> - </span>
                            </vs-td>
                            <vs-td :data="data[indextr].totalTaxAmount">
                              {{
                                Number(
                                  data[indextr].totalTaxAmount
                                ).toLocaleString()
                              }}
                              ریال
                            </vs-td>
                            <vs-td :data="data[indextr].price">
                              {{ Number(data[indextr].price).toLocaleString() }}
                              ریال
                            </vs-td>
                            <vs-td>
                              <span
                                v-if="
                                  data[indextr].orderProductInfoQuery
                                    .serializeSerial != ''
                                "
                              >
                                <vs-button
                                  color="primary"
                                  type="border"
                                  icon-pack="feather"
                                  icon="icon-edit"
                                  class="simple-bordered-btn"
                                  @click.prevent="
                                    addSerial(
                                      tr.orderProductInfoQuery.serializeSerial,
                                      indextr
                                    )
                                  "
                                  >{{ $t("SerialNumbers") }}</vs-button
                                >
                              </span>
                              <span
                                v-if="
                                  data[indextr].orderProductInfoQuery
                                    .serializeSerial == ''
                                "
                                >-</span
                              >
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                      <h5 class="text-left total-price">
                        {{ $t("TotalAmountForPayment") }}:
                        {{
                          Number(
                            orderInfo.totalAmountForPayment
                          ).toLocaleString()
                        }}
                        ریال
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mt-1">
                <label class="vs-select--label">{{
                  $t("WarehouseName")
                }}</label>
                <v-select
                  label="name"
                  name="warehouse"
                  :options="allWarehouses"
                  v-model="model.storeId"
                  v-validate="{ required: true }"
                  :reduce="(x) => x.id"
                  @input="changeWarehouse"
                  ref="warehouseSelect"
                  :clearable="true"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm mt-3"
                  v-show="errors.has('warehouse')"
                  >{{ errors.first("warehouse") }}</span
                >
              </div>
              <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mt-1">
                <label class="vs-select--label">{{ $t("ShelveName") }}</label>
                <v-select
                  label="name"
                  name="shelve"
                  :options="shelves"
                  v-model="model.shelveId"
                  :reduce="(x) => x.id"
                  v-validate="{ required: true }"
                  ref="shelveSelect"
                  @input="shelveSelect"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm mt-3"
                  v-show="errors.has('shelve')"
                  >{{ errors.first("shelve") }}</span
                >
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button
                  type="filled"
                  class="float-right"
                  @click.prevent="returnOrder()"
                  :disabled="disabled"
                  >{{ $t("ReturnOrders") }}</vs-button
                >
              </div>
            </div>
            <serial-popup
              :show="SerialPopup"
              @finish="onfinish"
              :serialRowIndex="serialRowIndex"
              :selectedSerials="selectedSerials"
              :serials="serials"
              @clicked="onClickChild"
            ></serial-popup>
          </div>
          <div v-else>
            <div id="loading-grid">
              <svg
                class="spinner"
                width="65px"
                height="65px"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  class="path"
                  fill="none"
                  stroke-width="6"
                  stroke-linecap="round"
                  cx="33"
                  cy="33"
                  r="30"
                ></circle>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.date {
  font-size: 0.9rem;
  color: #626262;
  font-weight: normal;
}

.total-price {
  background-color: #c8c8c8;
  color: #58595b;
  padding: 1rem;
}

.text-center input[type="text"] {
  text-align: center !important;
}

.vs-input--input:disabled {
  background-color: #ececec !important;
  border-color: #ececec !important;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import { mapGetters, mapActions, mapState } from "vuex";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import vSelect from "@/components/CustomVSelect.vue";
import { Validator } from "vee-validate";
import SerialPopup from "./SerialPopup.vue";

const dict = {
  custom: {
    warehouse: {
      required: "لطفا نام انبار را انتخاب نمایید.",
    },
    shelve: {
      required: "لطفا نام قفسه را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_ReturnOrders_Create",

  data() {
    return {
      ...mapState({
        mainmodel: "returnOrder/model",
      }),
      allOrdersLoading: false,
      partySelected: false,
      loadTable: false,
      disabled: false,
      serials: [],
      rowSerial: [],
      orderInfo: {},
      SerialPopup: false,
      serialRowIndex: "",
      selectedSerials: [],
      returnOrderItemsCommand: [],
      selectedSerialArray: [],
      fromChild: "",
      model: {
        orderId: "",
        storeId: "",
        shelveId: "",
        shelveName: "",
        returnOrderItemsCommand: [],
      },
      searchQueryNew: "",
      searchQueryOld: "",
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
      orderInfoLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      allOrders: "partyOrderInfo/list",
      order: "order/details",
      allWarehouses: "warehouse/list",
    }),

    shelves() {
      var warehouse = this.$store.getters["warehouse/list"].find(
        (obj) => obj.id == this.model.storeId
      );
      return warehouse ? warehouse.shelveQueries : [];
    },
  },
  mounted() {
    this.fetchWarehouses();
    this.emptyFileInRefs = this.$refs.file.files;
  },
  methods: {
    ...mapActions({
      importExcelReturnOrder: "excel/importExcelReturnOrder",
      fetchCustomerSearch: "parties/fetchPartiesSearch",
      fetchPartyOrders: "partyOrderInfo/fetchNoSkip",
      fetchOrderInfo: "order/fetchSingle",
      fetchWarehouses: "warehouse/fetchListWithNOTakeSkip",
      // readWarehousesWithoutTakeSkip: "warehouse/readWarehousesWithoutTakeSkip",
      returnOrderInfo: "returnOrder/create",
      setSelectedTransactionIndex: "returnOrder/setSelectedTransactionIndex",
    }),
    onPartyChange(input) {
      if (!input) {
        this.partySelected = false;
        this.loadTable = false;
      }
    },
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchCustomerSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name + " - " + element.socialSecurityNumber,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    getLabel(option) {
      return `شماره فاکتور: ${option.id} (${
        option.createOn
      }) - - - مبلغ کل: ${Number(
        option.totalAmountForPayment
      ).toLocaleString()}`;
    },
    onPartySelected(party) {
      this.model = {
        orderId: "",
        storeId: "",
        shelveId: "",
        shelveName: "",
        returnOrderItemsCommand: [],
      };
      if (party.id) {
        this.loadTable = false;
        this.partySelected = true;
        this.allOrdersLoading = true;
        this.fetchPartyOrders(party.id).then(() => {
          this.allOrdersLoading = false;
        });
      }
    },
    selectOrder() {
      if (this.model.orderId) {
        this.selectedSerialArray = [];
        this.orderInfoLoading = true;
        this.loadTable = true;
        this.fetchOrderInfo(this.model.orderId).then((response) => {
          this.orderInfoLoading = false;
          this.orderInfo = response;
          var array = this.orderInfo.ordersItemsQueryDto;
          this.model.returnOrderItemsCommand = [];
          for (let i = 0; i < array.length; i++) {
            this.model.returnOrderItemsCommand.push({
              productId: array[i].orderProductInfoQuery.productId,
              count:
                array[i].orderProductInfoQuery.productType === "Serial"
                  ? null
                  : array[i].count,
              serials: null,
            });
            this.selectedSerialArray.push({
              serials: array[i].orderProductInfoQuery.serializeSerial
                ? array[i].orderProductInfoQuery.serializeSerial
                : null,
            });
          }
          for (let i = 0; i < this.orderInfo.ordersItemsQueryDto.length; i++) {
            this.orderInfo.ordersItemsQueryDto.forEach(function (element) {
              element.returnCount = null;
            });
          }
        });
      }
    },
    changeWarehouse() {
      this.$refs.shelveSelect.clearSelection();
      this.model.shelveName = "";
    },
    shelveSelect() {
      if (this.model.shelveId) {
        this.model.shelveName = this.shelves.filter(
          (x) => x.id == this.model.shelveId
        )[0].name;
      } else {
        this.model.shelveName = "";
      }
    },
    changeCount(i, event) {
      this.model.returnOrderItemsCommand[i].count = event.target.value;
    },
    returnOrder() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$swal({
            title: "آیا از برگشت این فاکتور اطمینان دارید؟",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "بلی",
            cancelButtonText: "خیر",
          }).then((result) => {
            if (result.value) {
              for (
                let i = 0;
                i < this.model.returnOrderItemsCommand.length;
                i++
              ) {
                if (this.orderInfo.ordersItemsQueryDto[i].returnCount == "") {
                  this.model.returnOrderItemsCommand[i].count = null;
                } else {
                  this.model.returnOrderItemsCommand[i].count =
                    this.orderInfo.ordersItemsQueryDto[i].returnCount;
                }
              }
              for (
                let i = 0;
                i < this.model.returnOrderItemsCommand.length;
                i++
              ) {
                if (
                  this.model.returnOrderItemsCommand[i].count == null &&
                  this.model.returnOrderItemsCommand[i].serials == null
                ) {
                  this.model.returnOrderItemsCommand.splice(i, 1);
                  --i;
                }
              }
              this.disabled = true;
              this.returnOrderInfo(this.model)
                .then(() => {
                  this.$swal({
                    position: "center-center",
                    type: "success",
                    text: "فاکتور موردنظر با موفقیت برگشت داده شد",
                    showConfirmButton: false,
                    timer: 4000,
                  }).then(() => {
                    this.$router.push("/ReturnOrders/Index");
                  });
                })
                .catch(() => {
                  this.disabled = false;
                });
            }
          });
        }
      });
    },
    addSerial(serials, index) {
      if (this.model.returnOrderItemsCommand[index].serials) {
        this.selectedSerials =
          this.model.returnOrderItemsCommand[index].serials;
      } else {
        this.selectedSerials = [];
      }
      var array = this.selectedSerialArray[index].serials;
      this.serials = array.split(",");
      this.SerialPopup = true;
      this.serialRowIndex = index;
    },
    onfinish() {
      this.SerialPopup = false;
    },
    onClickChild(value, index) {
      if (value == "") {
        this.model.returnOrderItemsCommand[index].serials = null;
        this.orderInfo.ordersItemsQueryDto[index].returnCount = null;
      } else {
        this.model.returnOrderItemsCommand[index].serials = value;
        this.orderInfo.ordersItemsQueryDto[index].returnCount =
          this.model.returnOrderItemsCommand[index].serials.length;
      }
      this.selectedSerials = value;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importExcelReturnOrder(formData).then(() => {});
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
      }, 1000);
    },
  },
  components: {
    "v-select": vSelect,
    Treeselect,
    SerialPopup,
  },
};
</script>
